import { on } from "delegated-events";

const siteHeader = document.querySelector(".site-header");
const siteMenu = document.querySelector(".site-menu");

export default {
  init: () => {
    const scrollPixel = document.querySelector(".scroll-pixel");

    if (scrollPixel && siteHeader) {
      const observer = new IntersectionObserver(
        ([e]) => siteHeader.classList.toggle("is-stuck", e.intersectionRatio < 1),
        {
          threshold: [1],
        },
      );

      observer.observe(document.querySelector(".scroll-pixel"));
    }

    on("click", ".site-menu-open", () => {
      siteMenu.classList.remove("invisible");
      siteMenu.offsetHeight;
      document.documentElement.classList.add("js-menu-active");
    });

    on("click", ".site-menu-close", () => {
      document.documentElement.classList.remove("js-menu-active");

      siteMenu.addEventListener(
        "transitionend",
        () => {
          siteMenu.classList.add("invisible");
        },
        { once: true },
      );
    });
  },
};
